import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components.
import Error from 'components/Error';

// Actions.
import * as ProfileActions from 'actions/ProfileActions';

@connect(
  state => ({
    error: state.error,
    profile: state.profile,
  }),
  dispatch => ({
    profileActions: bindActionCreators(ProfileActions, dispatch),
  })
)
export default class ErrorPage extends Component {
  constructor() {
    super();
    window.location.replace('/500/')
  }

  static propTypes = {
    error: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    profileActions: PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    if (!this.props.profile.isFetched) {
      this.props.profileActions.loadUserProfile();
    }
  }

  render() {
    return null

    const { error } = this.props;
    return <Error error={error} />;
  }

}
